module.exports = __webpack_public_path__ + "img/mobile-menu-promotion.85bc0b54.webp";